<template>
  <div class="main user-layout-register login-wrap">
    <div class="login-logo">
      <img src="../../assets/elinkx/login/logo.png" alt="" style="width:140px;">
    </div>
    <div class="login-wrap-con">
      <div class="login-left">
        <div class="" style="margin-top:58px;margin-left:30px;">
          <vue-qr
            :text="codeUrl"
            :margin="0"
            colorDark="#000000"
            colorLight="#fff"
            :logoScale="0.2"
            :size="228"></vue-qr>
        </div>
        <!-- <img src="../../assets/elinkx/code.png" alt="" style="width:228px;margin-top:58px;margin-left:30px;"> -->
      </div>
      <div class="login-right">
        <img src="../../assets/elinkx/login/loginRight.png" alt="" style="width:355px;">
        <p style="text-align: center;margin-top: -24px;">线上开课就要用的平台</p>
      </div>
    </div>

  </div>
</template>

<script>
  import { getTeacherLoginUrl, getToken } from '@/api/api'
  import vueQr from 'vue-qr'
  import { mapActions } from 'vuex'
  export default {
    name: 'ScanCodeLogin',
    mixins: [],
    components: {
      vueQr
    },
    data() {
      return {
        codeUrl: '',
        timer: '',
        id: ''
      }
    },
    methods: {
      ...mapActions(['CodeLogin']),
      getUrl () {
        getTeacherLoginUrl().then((res) => {
          this.codeUrl = res.result.url
          this.id = res.result.id
        })
      },
      getToken () {
        getToken({
          id: this.id
        }).then((res) => {
          let status = res.success
          if (status) {
            this.$message.success('登录成功')
            clearInterval(this.timer)
            this.CodeLogin(res)
            // Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
          } else {
            // this.$message.warning(res.message)
          }
        })
      }
    },
    created () {
      this.getUrl()
      this.timer = setInterval(() => {
        this.getToken()
      }, 2000)
    }
  }
</script>
<style lang="scss" scoped>

  .login-wrap{
    width:847px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -290px;
    margin-left: -420px;
    .login-logo{
      margin-bottom:20px;
    }
    .login-wrap-con{
      width:847px;
      height:477px;
      box-shadow:0px 1px 10px 5px rgba(0,0,0,0.06);
      // padding:50px 60px;
      .login-left{
        width:300px;
        display:inline-block;
        vertical-align: middle;
        height:359px;
      }
      .login-right{
        margin-left:70px;
        display:inline-block;
        vertical-align: middle;
      }

    }
    .randCode{
      canvas{
        width:118px;
        height:40px;
      }
    }
    .ant-btn-primary{
      background-color:#0158D2;
    }
  }

  .user-register {

    &.error {
      color: #ff0000;
    }

    &.warning {
      color: #ff7e05;
    }

    &.success {
      color: #52c41a;
    }

  }

  .user-layout-register {
    .ant-input-group-addon:first-child {
      background-color: #fff;
    }
  }
</style>
<style lang="scss" scoped>
  .user-layout-register {

    & > h3 {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
      font-size:12px;
    }

    .register-button {
      width: 100%;
      line-height: 40px;
      height: 40px;
    }
    .has-account{
      text-align: center;
      .login {
        // float: right;
        // line-height: 40px;
      }
    }

  }
</style>
